module.exports = __webpack_public_path__ + "img/washing-machine.775d4f89.svg";